// Analytics-related attribute constants
export const ANALYTICS_ID_ATTR = 'data-analyticsid'
export const ANALYTICS_PREFIX = 'data-analytics-'
